module.exports = __webpack_public_path__ + "static/media/0024_IMG_FE_LE_PLAFOND_RAL_9010.c82e80ae.png";